import { useState, useEffect } from "react";
import { PlanetProps, DATA_PLANET, get_planet } from "Data/planet";
import { ajax_get } from "Data/detail";

const usePlanetData = () => {
	const [data, setData] = useState<PlanetProps[]>();

	useEffect(() => {
		const get = () => {
			ajax_get('http://project42.abclab.kr/admin/index.php/wp-json/wp/v2/zplanet/?per_page=100', (data: object) => {
				setData(get_planet(data));
			});
		};
		get();
	}, []);

	return { data, setData };
};

export default usePlanetData;
